// extracted by mini-css-extract-plugin
export default {"terms":"Privacy_terms__Ganbo","header":"Privacy_header__BchNz"};